export const SPECIALIZE_CREATE_REQUEST = 'SPECIALIZE_CREATE_REQUEST'
export const SPECIALIZE_CREATE_SUCCESS = 'SPECIALIZE_CREATE_SUCCESS'
export const SPECIALIZE_CREATE_FAIL = 'SPECIALIZE_CREATE_FAIL'
export const SPECIALIZE_CREATE_RESET = 'SPECIALIZE_CREATE_RESET'


export const LIST_SPECIALIZE_REQUEST = 'LIST_SPECIALIZE_REQUEST'
export const LIST_SPECIALIZE_SUCCESS = 'LIST_SPECIALIZE_SUCCESS'
export const LIST_SPECIALIZE_FAIL = 'LIST_SPECIALIZE_FAIL'
export const LIST_SPECIALIZE_RESET = 'LIST_SPECIALIZE_RESET'



export const SPECIALIZE_DELETE_REQUEST = 'SPECIALIZE_DELETE_REQUEST'
export const SPECIALIZE_DELETE_SUCCESS = 'SPECIALIZE_DELETE_SUCCESS'
export const SPECIALIZE_DELETE_FAIL = 'SPECIALIZE_DELETE_FAIL'

export const SPECIALIZE_UPDATE_REQUEST = 'SPECIALIZE_UPDATE_REQUEST'
export const SPECIALIZE_UPDATE_SUCCESS = 'SPECIALIZE_UPDATE_SUCCESS'
export const SPECIALIZE_UPDATE_FAIL = 'SPECIALIZE_UPDATE_FAIL'
export const SPECIALIZE_UPDATE_RESET = 'SPECIALIZE_UPDATE_RESET'


export const SPECIALIZE_DETAILS_REQUEST = 'SPECIALIZE_DETAILS_REQUEST'
export const SPECIALIZE_DETAILS_SUCCESS = 'SPECIALIZE_DETAILS_SUCCESS'
export const SPECIALIZE_DETAILS_FAIL = 'SPECIALIZE_DETAILS_FAIL'